import { Spinner } from "@/components/common/Spinner";

/** HITL の回答を送信中であることを示す一行。 */
export function HITLSubmittingNote() {
	return (
		<p className="flex min-w-0 items-center gap-1.5 text-caption text-fg-3">
			<Spinner size={10} color="var(--fg-3)" />
			送信中…
		</p>
	);
}
